import React from 'react';
import Lock from 'lucide-react/dist/esm/icons/lock';
import Heart from 'lucide-react/dist/esm/icons/heart';
import Users from 'lucide-react/dist/esm/icons/users';

const LandingBenefits = ({ t }) => {
  return (
    <>
      {/* ===== SECCION 3: LA SOLUCION (Beneficios) ===== */}
      <section className="px-4 py-16" style={{ backgroundColor: '#F9F9F6' }}>
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 
              className="text-3xl md:text-4xl mb-4"
              style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              data-testid="benefits-title"
            >
              {t('landing.benefits.title')}
            </h2>
            <p 
              className="text-lg md:text-xl max-w-2xl mx-auto"
              style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
            >
              {t('landing.benefits.subtitle')}
            </p>
          </div>
          
          {/* 3 Beneficios con Imagenes */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Beneficio 1: Tu Escudo */}
            <div className="text-center">
              <div 
                className="rounded-2xl overflow-hidden mb-4"
                style={{ 
                  backgroundColor: '#F9F9F6',
                  border: '3px solid #2C2C2C',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.15)'
                }}
              >
                <img 
                  src="/paso-1-app.webp" 
                  alt={t('landing.benefits.shield.title')}
                  className="w-full h-56 md:h-64 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </div>
              <h3 
                className="text-xl md:text-2xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
              >
                {t('landing.benefits.shield.title')} {t('landing.benefits.shield.emoji')}
              </h3>
              <p 
                className="text-base"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.benefits.shield.text')}
              </p>
            </div>
            
            {/* Beneficio 2: Tu Confianza */}
            <div className="text-center">
              <div 
                className="rounded-2xl overflow-hidden mb-4"
                style={{ 
                  backgroundColor: '#F9F9F6',
                  border: '3px solid #2C2C2C',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.15)'
                }}
              >
                <img 
                  src="/paso-2-pareja.webp" 
                  alt={t('landing.benefits.confidence.title')}
                  className="w-full h-56 md:h-64 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </div>
              <h3 
                className="text-xl md:text-2xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
              >
                {t('landing.benefits.confidence.title')} {t('landing.benefits.confidence.emoji')}
              </h3>
              <p 
                className="text-base"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.benefits.confidence.text')}
              </p>
            </div>
            
            {/* Beneficio 3: Tu Libertad */}
            <div className="text-center">
              <div 
                className="rounded-2xl overflow-hidden mb-4"
                style={{ 
                  backgroundColor: '#F9F9F6',
                  border: '3px solid #2C2C2C',
                  boxShadow: '5px 5px 0 rgba(44,44,44,0.15)'
                }}
              >
                <img 
                  src="/paso-3-playa.webp" 
                  alt={t('landing.benefits.freedom.title')}
                  className="w-full h-56 md:h-64 object-cover"
                  style={{ mixBlendMode: 'multiply' }}
                />
              </div>
              <h3 
                className="text-xl md:text-2xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#27AE60' }}
              >
                {t('landing.benefits.freedom.title')} {t('landing.benefits.freedom.emoji')}
              </h3>
              <p 
                className="text-base"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.benefits.freedom.text')}
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* ===== SECCION 4: CONFIANZA (Privacidad) ===== */}
      <section className="px-4 py-16" style={{ backgroundColor: '#FFFFFF' }}>
        <div className="max-w-4xl mx-auto">
          <h2 
            className="text-3xl md:text-4xl text-center mb-12"
            style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
            data-testid="privacy-title"
          >
            {t('landing.privacy.title')}
          </h2>
          
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Sin Claves Bancarias */}
            <div 
              className="text-center p-6 rounded-2xl"
              style={{ 
                backgroundColor: '#F9F9F6',
                border: '2px solid #2C2C2C',
                boxShadow: '4px 4px 0 rgba(44,44,44,0.1)'
              }}
            >
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#E8F5E9' }}
              >
                <Lock className="w-8 h-8" style={{ color: '#27AE60' }} />
              </div>
              <h3 
                className="text-xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              >
                {t('landing.privacy.noPasswords.title')}
              </h3>
              <p 
                className="text-sm"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.privacy.noPasswords.text')}
              </p>
            </div>
            
            {/* Sin Juicios */}
            <div 
              className="text-center p-6 rounded-2xl"
              style={{ 
                backgroundColor: '#F9F9F6',
                border: '2px solid #2C2C2C',
                boxShadow: '4px 4px 0 rgba(44,44,44,0.1)'
              }}
            >
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#E8F5E9' }}
              >
                <Users className="w-8 h-8" style={{ color: '#27AE60' }} />
              </div>
              <h3 
                className="text-xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              >
                {t('landing.privacy.noJudgment.title')}
              </h3>
              <p 
                className="text-sm"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.privacy.noJudgment.text')}
              </p>
            </div>
            
            {/* 100% Privado */}
            <div 
              className="text-center p-6 rounded-2xl"
              style={{ 
                backgroundColor: '#F9F9F6',
                border: '2px solid #2C2C2C',
                boxShadow: '4px 4px 0 rgba(44,44,44,0.1)'
              }}
            >
              <div 
                className="w-16 h-16 rounded-full flex items-center justify-center mx-auto mb-4"
                style={{ backgroundColor: '#E8F5E9' }}
              >
                <Heart className="w-8 h-8" style={{ color: '#27AE60' }} />
              </div>
              <h3 
                className="text-xl mb-2"
                style={{ fontFamily: "'Patrick Hand', cursive", color: '#2C2C2C' }}
              >
                {t('landing.privacy.private.title')}
              </h3>
              <p 
                className="text-sm"
                style={{ fontFamily: "'Nunito', sans-serif", color: '#4A4A4A' }}
              >
                {t('landing.privacy.private.text')}
              </p>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default LandingBenefits;
